import { IconButton } from "@mui/material";
import {
  Trash2 as DeleteIcon,
  Pencil as EditIcon,
  Eye as VisibilityIcon,
} from "lucide-react";
import { useHistory } from "react-router-dom";
import { Cell } from "react-table";

import { CustomersType } from "api/customers/types";
import { hasPermissions } from "components/stores/UserStore";

// LOGIC:
// import { hasPermissions } from "components/stores/UserStore";

interface Props<T extends {}> extends Cell<T> {
  handleOpenEdit: (ctx?: T) => void;
  handleOpenDelete: (ctx?: T) => void;
}

const ActionsFormatter = ({
  row,
  handleOpenEdit,
  handleOpenDelete,
}: Props<CustomersType>) => {
  const history = useHistory();

  return (
    <div>
      <IconButton
        color="primary"
        onClick={() => history.push(`/customers/${row.original._id}`)}
      >
        <VisibilityIcon />
      </IconButton>
      {hasPermissions("update:customers") && (
        <IconButton
          // data-testid="edit-port-button"
          color="warning"
          onClick={() => handleOpenEdit(row.original)}
        >
          <EditIcon />
        </IconButton>
      )}
      {hasPermissions("delete:customers") && (
        <IconButton
          // data-testid="delete-port-button"
          color="error"
          onClick={() => handleOpenDelete(row.original)}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ActionsFormatter;
